/* GLOWie motion layer: self-drawing doodles, marker cursor, glow trail, mascot blink */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- doodles draw themselves on scroll ---------- */
  function initDoodles() {
    var els = document.querySelectorAll('.glowie-dood');
    els.forEach(function (sv) {
      sv.querySelectorAll('path,circle,ellipse,polyline').forEach(function (p) {
        var L = 600;
        try { L = p.getTotalLength(); } catch (e) {}
        L = Math.ceil(L);
        p.style.strokeDasharray = L;
        p.style.strokeDashoffset = reduce ? 0 : L;
      });
    });
    if (reduce) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.querySelectorAll('path,circle,ellipse,polyline').forEach(function (p, i) {
          setTimeout(function () { p.style.strokeDashoffset = 0; }, i * 110);
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    els.forEach(function (s) { io.observe(s); });
  }

  /* ---------- mascot blink ---------- */
  function initBlink() {
    if (reduce) return;
    document.querySelectorAll('.glowie-mascot').forEach(function (g) {
      function shut(ms) {
        g.classList.add('blink');
        setTimeout(function () { g.classList.remove('blink'); }, ms);
      }
      (function loop() {
        setTimeout(function () {
          shut(130);
          if (Math.random() < 0.28) setTimeout(function () { shut(120); }, 330);
          loop();
        }, 2600 + Math.random() * 4200);
      })();
    });
  }

  /* ---------- glow trail + marker cursor ---------- */
  function initCursor() {
    if (reduce) return;
    var cv = document.getElementById('glowie-trail');
    var nib = document.getElementById('glowie-nib');
    if (!cv || !nib) return;
    var ctx = cv.getContext('2d');
    var pts = [], dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() {
      cv.width = innerWidth * dpr; cv.height = innerHeight * dpr;
      cv.style.width = innerWidth + 'px'; cv.style.height = innerHeight + 'px';
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.scale(dpr, dpr);
    }
    size();
    addEventListener('resize', size, { passive: true });

    var drawing = false, lastMove = 0;
    function push(x, y) {
      pts.push({ x: x, y: y, t: performance.now() });
      if (pts.length > 90) pts.shift();
      drawing = true; lastMove = performance.now();
    }
    (function frame(now) {
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      while (pts.length && now - pts[0].t > 750) pts.shift();
      for (var i = 1; i < pts.length; i++) {
        var p = pts[i], q = pts[i - 1], a = Math.max(0, 1 - (now - p.t) / 750);
        ctx.beginPath(); ctx.moveTo(q.x, q.y); ctx.lineTo(p.x, p.y);
        ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.strokeStyle = 'rgba(48,216,240,' + (a * 0.5).toFixed(3) + ')';
        ctx.lineWidth = 13 * a; ctx.stroke();
        ctx.strokeStyle = 'rgba(255,255,255,' + (a * 0.55).toFixed(3) + ')';
        ctx.lineWidth = 4 * a; ctx.stroke();
      }
      if (now - lastMove > 140 && drawing) {
        drawing = false; document.body.classList.remove('nib-draw');
      }
      requestAnimationFrame(frame);
    })(performance.now());

    var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    var nx = 0, ny = 0, tx = 0, ty = 0;
    if (fine) {
      document.body.classList.add('nib-on');
      (function follow() {
        nx += (tx - nx) * 0.34; ny += (ty - ny) * 0.34;
        nib.style.transform = 'translate(' + nx + 'px,' + ny + 'px)';
        requestAnimationFrame(follow);
      })();
    }

    addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      push(e.clientX, e.clientY);
      document.body.classList.add('nib-draw');
    }, { passive: true });

    addEventListener('touchmove', function (e) {
      var t = e.touches[0]; if (t) push(t.clientX, t.clientY);
    }, { passive: true });

    document.addEventListener('mouseover', function (e) {
      var hot = e.target.closest && e.target.closest('a,button,summary,input,select');
      document.body.classList.toggle('nib-hot', !!hot);
    });
  }

  function boot() { initDoodles(); initBlink(); initCursor(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
